<template>
  <nav class="mb-8">
    <v-app-bar app color="primary" dark >

      <v-toolbar class="primary mx-auto" flat max-width="1200">
        <v-toolbar-title>
          <span class="bold">MIEMSS </span>
          <span> Online Training Center</span>
        </v-toolbar-title>
      </v-toolbar>
    </v-app-bar>
  </nav>
</template>

<script>
export default {
  data: () => ({
    links: [
      { text: "Register", route: "/register" },
      {
        text: "Online Training Center",
        route: "https://www.emsonlinetraining.org",
      },
    ],
  }),
};
</script>

<style scoped>
.bold {
  font-size: 1.5rem;
}
</style>